import React from 'react'
import { Flex } from '@mprolab/uikit'
import loading from 'react-useanimations/lib/loading'
import UseAnimations from 'react-useanimations'
import { useTheme } from 'styled-components'

const LoadingComponent: React.FC<{ fullHeight?: boolean }> = ({ fullHeight }) => {
  const { colors } = useTheme()
  return (
    <Flex justifyContent="center" alignItems="center" padding={30} height={fullHeight ? '100%' : 'auto'}>
      <UseAnimations animation={loading} strokeColor={colors.white} size={64} />
    </Flex>
  )
}

export default LoadingComponent
